// TalentPerformance — bilingual user-facing error translation.
import { formatApiError } from '@/lib/api';

const KNOWN = new Set([
  'tp_cycle_not_found', 'tp_evaluation_not_found', 'tp_cycle_not_draft',
  'tp_cycle_closed', 'tp_cycle_not_active', 'tp_cycle_not_closed',
  'tp_no_fronts_enabled', 'tp_weights_must_total_100', 'tp_front_missing_instrument',
  'tp_front_instrument_unpublished', 'tp_cycle_has_no_employees',
  'tp_missing_supervisor', 'tp_missing_internal_evaluators',
  'tp_subject_already_in_cycle', 'tp_evaluator_invalid', 'tp_invalid_front',
  'tp_front_no_data', 'tp_results_not_ready', 'tp_results_not_released',
  'tp_not_your_evaluation', 'tp_invalid_ack_status', 'tp_invalid_plan_item',
  'tp_plan_item_not_found', 'tp_already_sent_to_talenttrain',
  'tp_talenttrain_not_contracted', 'tp_thresholds_inconsistent',
  'tp_instrument_not_found', 'invalid_format',
]);

export function tpError(t, e) {
  let d = e?.response?.data?.detail;
  if (d && typeof d === 'object' && d.code) {
    if (KNOWN.has(d.code)) {
      return t(`talentperformance.errors.${d.code}`, { employee: d.employee || '' });
    }
  }
  if (typeof d === 'string' && KNOWN.has(d)) {
    return t(`talentperformance.errors.${d}`);
  }
  return formatApiError(e);
}
